<script>
  export let data;
</script>

<style></style>

<div class="fc px-sm pb-md sy-sm max-w-2xl">
  <div class="sy-xs">
    <h3>{data.header}</h3>
    <h4>{data.title}</h4>
  </div>
  {#each data.text as text}
    <p class="p2">{text}</p>
  {/each}
</div>

